import clsx from 'clsx';
import { ButtonHTMLAttributes, PropsWithChildren } from 'react';

interface OutlineButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  isLoading?: boolean;
  loaderSize?: number;
  active?: boolean;
}

export const OutlineButton = ({
  children,
  onClick,
  className,
  disabled,
  active
}: PropsWithChildren<OutlineButtonProps>) => {
  return (
    <button
      className={clsx(
        'yep_ex-bg-white yep_ex-text-neutral-600 yep_ex-rounded-md yep_ex-text-sm/5 yep_ex-font-medium yep_ex-px-4 yep_ex-py-2.5 yep_ex-border yep_ex-border-neutral-200',
        className,
        disabled && 'yep_ex-text-neutral-200',
        active && 'yep_ex-border-primary-600'
      )}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
